export default "__VITE_ASSET__CBAB7tAU__"